module.exports = __webpack_public_path__ + "static/media/3rdplace.57ba978b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/3rdplace.svg
// module id = 129
// module chunks = 0